// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: 74swX8o1_CEp
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicClientsListCard.module.css"; // plasmic-import: 74swX8o1_CEp/css

createPlasmicElementProxy;

export const PlasmicClientsListCard__VariantProps = new Array();

export const PlasmicClientsListCard__ArgProps = new Array(
  "clientName",
  "clientEmail",
  "date",
  "status"
);

const $$ = {};

function PlasmicClientsListCard__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <Stack__
      as={"div"}
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__m0IbS)}>
        {renderPlasmicSlot({
          defaultContents: "Nike",
          value: args.clientName,
          className: classNames(sty.slotTargetClientName)
        })}
      </div>
      <div
        data-plasmic-name={"clientEmail"}
        data-plasmic-override={overrides.clientEmail}
        className={classNames(projectcss.all, sty.clientEmail)}
      >
        {renderPlasmicSlot({
          defaultContents: "john@nike.com",
          value: args.clientEmail,
          className: classNames(sty.slotTargetClientEmail)
        })}
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__fxRjk)}>
        {renderPlasmicSlot({
          defaultContents: "Dec 28th, 12:25 AM",
          value: args.date,
          className: classNames(sty.slotTargetDate)
        })}
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__e35Lc)}>
        {renderPlasmicSlot({
          defaultContents: "Needs Documentation",
          value: args.status,
          className: classNames(sty.slotTargetStatus)
        })}
      </div>
    </Stack__>
  );
}

const PlasmicDescendants = {
  root: ["root", "clientEmail"],
  clientEmail: ["clientEmail"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicClientsListCard__ArgProps,
          internalVariantPropNames: PlasmicClientsListCard__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicClientsListCard__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicClientsListCard";
  } else {
    func.displayName = `PlasmicClientsListCard.${nodeName}`;
  }
  return func;
}

export const PlasmicClientsListCard = Object.assign(
  // Top-level PlasmicClientsListCard renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    clientEmail: makeNodeComponent("clientEmail"),
    // Metadata about props expected for PlasmicClientsListCard
    internalVariantProps: PlasmicClientsListCard__VariantProps,
    internalArgProps: PlasmicClientsListCard__ArgProps
  }
);

export default PlasmicClientsListCard;
/* prettier-ignore-end */
